import Api from '@/services/Api';
import axios from 'axios';

const token = localStorage.getItem('access_token');
const urlRichiesta = 'https://sviluppoallergeni.confcom.it';

export default {
    // CLIENTE
    createCliente(dati) {
        return Api().post('/antiriciclaggio/clienti', dati);
    },

    updateCliente(dati, idCliente) {
        return Api().put('/antiriciclaggio/clienti/' + idCliente, dati);
    },

    // GET /antiriciclaggio/clienti/:id -> vedere informazioni singolo cliente
    getCliente(id) {
        return Api().get('/antiriciclaggio/clienti/' + id);
    },

    getAllClienti() { // ottieni tutti i clienti 
        return Api().get('/antiriciclaggio/clienti');
    },

    // POST /antiriciclaggio/clienti/meta/:id
    caricaDocumentoCliente(id, formData) {
        return axios.create({
          baseURL: urlRichiesta,
          withCredentials: true,
          headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        }).post('/antiriciclaggio/clienti/meta/'+ id, formData);
    },
    caricaDocumentoAV(id, formData, type) {
        return axios.create({
          baseURL: urlRichiesta,
          withCredentials: true,
          headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        }).post('/antiriciclaggio/clienti/meta/'+ id + '?TYPE=' + type, formData);
    },

    //  SOGGETTO
    // POST /soggetti/:idcliente -> per greare soggetto collegato a cliente
    createSoggetto(dati, idCliente) {
        return Api().post('/antiriciclaggio/clienti/soggetti/' + idCliente, dati);
    },

    updateSoggetto(dati, idCliente, idSoggetto) {
        return Api().put('/antiriciclaggio/clienti/soggetti/' + idCliente + '/' + idSoggetto, dati);
    },

    // GET /soggetti/:idcliente/:idsoggetti -> per vedere singolo soggetto
    getSoggetto(idCliente, idSoggetto) {
        return Api().get('/antiriciclaggio/clienti/soggetti/' + idCliente + '/' + idSoggetto);
    },

    getAllSoggetti(idCliente) {
        return Api().get('/antiriciclaggio/clienti/soggetti/'+idCliente);
    },

    // POST POST /antiriciclaggio/clienti/soggetti/:idcliente/:idsoggetti/meta  -> caricare documenti cliente
    caricaDocumentoSoggetto(idCliente, idSoggetto, formData) {
        return axios.create({
          baseURL: urlRichiesta,
          withCredentials: true,
          headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        }).post('/antiriciclaggio/clienti/soggetti/' + idCliente + '/' + idSoggetto + '/meta', formData);
    },


    // PRESTAZIONI
    // POST /antiriciclaggio/clienti/prestazioni/:id
    createPrestazione(idCliente, dati) {
        return Api().post('/antiriciclaggio/clienti/prestazioni/' + idCliente, dati);
    },

    // PUT /prestazioni/:id -> aggiornarne una
    updatePrestazione(idCliente, idPrestazione, dati) {
        return Api().put('/antiriciclaggio/clienti/prestazioni/' + idCliente + '/' + idPrestazione, dati);
    },

    // GET /prestazioni -> vederle tutte
    getAllPrestazioni(idCliente) {
        return Api().get('/antiriciclaggio/clienti/prestazioni/' + idCliente);
    },

    // GET /prestazioni/:id -> vederne solo una
    getPrestazione(idCliente, idPrestazione) {
        return Api().get('/antiriciclaggio/clienti/prestazioni/' + idCliente + '/' + idPrestazione);
    },

    // per vedere tutti i tipi di prestazione 
    getPrestazioniTipo() {
        return Api().get('/antiriciclaggio/prestazioni/tipo');
    },

    // VALUTAZIONE
    // TAB B
   
    // creazione tab B
    createTabB(idCliente, idPrestazione, datiTabB) {
        return Api().put('/antiriciclaggio/clienti/prestazioni/' + idCliente + '/' + idPrestazione + '/TAB_B', datiTabB);
    },

    // creazione tab A
    createTabA(idCliente, idPrestazione, datiTabA) {
        return Api().put('/antiriciclaggio/clienti/' + idCliente + '/TAB_A', datiTabA);
    },


    // STATUS
    getStatus() {
        return Api().get('/antiriciclaggio/status');
    },

    updateRischio(idCliente, update) {
        return Api().put('/antiriciclaggio/clienti/' + idCliente + '/aggiorna_rischio?update=' + update);
    },

    //GET /antiriciclaggio/clienti/docx/:documentName/:id
    // per scaricare documento documentName -> AV1.docx
    downloadAV(documentName, idCliente) {
        return Api().get('/antiriciclaggio/clienti/docx/'+ documentName +'/' + idCliente);
    }
}